import Default from '@pages/home'
import CashbacksList from '@pages/cashbacks/list/list-cashbacks'

export default {
  path: '',
  name: 'home',
  components: {
    default: Default,
  },

  children: [{
    path: ':partner_id/',
    name: 'growth-cashback',
    components: { 
      default: CashbacksList,
    },
  }],
}